module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./StudioTrainView.js"));
	}, "StudioTrainView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StudioTrainView!./src/pages/Shop/Member/Agreements/StudioTrain/StudioTrainView.js
// module id = 947
// module chunks = 438